// import React from "react";
// import "./PropertyDetails.css";

// const PropertyDetails = () => {

//     //  const { id } = useParams();
//   return (


//     <div className="property-page">
//       {/* Image Section */}
//       <div className="image-wrapper">
//         <img
//           src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c"
//           alt="Property"
//         />
//         <div className="image-actions">
//           <button>←</button>
//           <div>
//             <button>⤴</button>
//             <button>🔖</button>
//           </div>
//         </div>
//       </div>

//       {/* Content */}
//       <div className="content-card">
//         <h1>Modern Office Complex 1</h1>
//         <p className="location">📍 Hitech City, Hyderabad, Telangana</p>

//         {/* Owner */}
//         <div className="owner-card">
//           <div className="owner-info">
//             <img
//               src="https://i.pravatar.cc/100"
//               alt="Owner"
//               className="owner-avatar"
//             />
//             <div>
//               <h4>Sivaji</h4>
//               <span>Property Owner</span>
//               <p className="phone">+91 98765 43210</p>
//             </div>
//           </div>
//           <button className="call-btn">📞</button>
//         </div>

//         {/* Verification */}
//         <div className="badges">
//           <span>✔ GST Verified</span>
//           <span>✔ Aadhaar Verified</span>
//         </div>

//         {/* Actions */}
//         <div className="action-buttons">
//           <button className="primary">📅 Book Site Visit</button>
//           <button className="outline">Contact Owner</button>
//         </div>

//         {/* Description */}
//         <section>
//           <h3>Description</h3>
//           <p>
//             Experience luxury living in this architectural masterpiece.
//             Featuring floor-to-ceiling windows, smart home automation,
//             and a private infinity pool.
//           </p>
//         </section>

//         {/* Facilities */}
//         <section>
//           <h3>Facilities</h3>
//           <div className="facilities">
//             <div>📶 Wi-Fi</div>
//             <div>🚗 Parking</div>
//             <div>🏊 Pool</div>
//             <div>📷 24/7 Sec</div>
//           </div>
//         </section>

//         {/* Documents */}
//         <section>
//           <h3>Documents</h3>
//           <div className="doc-card">
//             <span>📄 Title Deed</span>
//             <small>2.4 MB</small>
//             <button>⬇</button>
//           </div>
//           <div className="doc-card">
//             <span>📄 Land Survey</span>
//             <small>1.8 MB</small>
//             <button>⬇</button>
//           </div>
//           <div className="doc-card">
//             <span>📄 NOC Certificate</span>
//             <small>850 KB</small>
//             <button>⬇</button>
//           </div>
//         </section>
//       </div>
//     </div>
//   );
// };

// export default PropertyDetails;

// import React, { useState } from "react";
// import "./PropertyDetails.css";

// const images = [
//   "https://images.unsplash.com/photo-1600585154340-be6161a56a0c",
//   "https://images.unsplash.com/photo-1600210492493-0946911123ea",
//   "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c",
//   "https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b",
// ];

// const PropertyDetails = () => {
//   const [activeImage, setActiveImage] = useState(images[0]);

//   return (
//     <div className="property-page">

//       {/* TOP SECTION */}
//       <div className="top-section">

//         {/* LEFT – IMAGE GALLERY */}
//         <div className="gallery">
//           <div className="main-image">
//             <img src={activeImage} alt="Property" />
//           </div>

//           <div className="thumbnails">
//             {images.map((img, index) => (
//               <img
//                 key={index}
//                 src={img}
//                 alt="thumb"
//                 className={activeImage === img ? "active" : ""}
//                 onClick={() => setActiveImage(img)}
//               />
//             ))}
//           </div>
//         </div>

//         {/* RIGHT – CONTENT */}
//         <div className="content-card">
//           <h1>Modern Office Complex 1</h1>
//           <p className="location">📍 Hitech City, Hyderabad, Telangana</p>

//           {/* Owner */}
//           <div className="owner-card">
//             <div className="owner-info">
//               <img
//                 src="https://i.pravatar.cc/100"
//                 alt="Owner"
//                 className="owner-avatar"
//               />
//               <div>
//                 <h4>Sivaji</h4>
//                 <span>Property Owner</span>
//                 <p className="phone">+91 98765 43210</p>
//               </div>
//             </div>
//             <button className="call-btn">📞</button>
//           </div>

//           {/* Badges */}
//           <div className="badges">
//             <span>✔ GST Verified</span>
//             <span>✔ Aadhaar Verified</span>
//           </div>

//           {/* Buttons */}
//           <div className="action-buttons">
//             <button className="primary">📅 Book Site Visit</button>
//             <button className="outline">Contact Owner</button>
//           </div>

//           {/* Description */}
//           <h3>Description</h3>
//           <p>
//             Experience luxury living in this architectural masterpiece.
//             Featuring floor-to-ceiling windows and smart automation.
//           </p>
//         </div>
//       </div>

//       {/* DOCUMENTS SECTION */}
//       <section className="documents">
//         <h3>Documents</h3>

//         <div className="doc-card">
//           <span>📄 Title Deed</span>
//           <small>2.4 MB</small>
//           <button>⬇</button>
//         </div>

//         <div className="doc-card">
//           <span>📄 Land Survey</span>
//           <small>1.8 MB</small>
//           <button>⬇</button>
//         </div>

//         <div className="doc-card">
//           <span>📄 NOC Certificate</span>
//           <small>850 KB</small>
//           <button>⬇</button>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default PropertyDetails;


import React, { useState, useEffect } from "react";
import "./PropertyDetails.css";
import Header from "../Header";
import Footer from "../../LandingPage/Footer";
import { BsBuildings } from "react-icons/bs";
import { useLocation, useParams } from "react-router-dom";
import residential from './residential.png'
import axios from "axios";
import Modal from "react-modal";
Modal.setAppElement("#root");



const API_BASE = "https://api.propertygalleria.in/master/api";

const PropertyDetails = () => {
  // const [activeImage, setActiveImage] = useState(imageList[0]);

  //   const location = useLocation();
  // const property = location.state?.property;


  // const [activeImage, setActiveImage] = useState(imageList[0]);


  const location = useLocation();
  const { id } = useParams();
  console.log('this is product Details page')
  console.log('this is id', id)
  const [property, setProperty] = useState(location.state?.property || null);
  const [activeImage, setActiveImage] = useState("");
  const imageList = property?.property_images || [];

  useEffect(() => {
    if (!property) {
      axios
        .get(`${API_BASE}/get/projects`)
        .then(res => {
          const found = res.data.find(p => p.id == id);
          setProperty(found);
          setActiveImage(found?.property_images?.[0]);
        })
        .catch(console.error);
    } else {
      setActiveImage(property.property_images?.[0]);
    }
  }, [id]);



  const [isVisitModalOpen, setVisitModalOpen] = useState(false);

  const today = new Date();
  const todayDate = today.toISOString().split("T")[0];

  const currentTime = today.toTimeString().slice(0, 5);

  const [visitDate, setVisitDate] = useState(todayDate);
  const [visitTime, setVisitTime] = useState(currentTime);



  const handleBookVisit = async () => {
    const user = JSON.parse(localStorage.getItem("user"));

    if (!user) {
      alert("Please login first");
      return;
    }

    try {
      const res = await axios.post(
        `${API_BASE}/api/leads/book-site-visit`,
        {
          investor_id: user.id,
          property_id: property.id,
          property_title: property.title,
          location: property.location,
          visit_date: visitDate,
          visit_time: visitTime
        }
      );

      alert(res.data.message);
      setVisitModalOpen(false);
    } catch (err) {
      alert("Failed to book visit");
    }
  };
  console.log('this is property', property)

  const formatPrice = (num) => {

    if (num >= 10000000) {
      return (num / 10000000).toFixed(1).replace(".0", "") + "Cr";
    }

    if (num >= 100000) {
      return (num / 100000).toFixed(1).replace(".0", "") + "L";
    }

    if (num >= 1000) {
      return (num / 1000).toFixed(1).replace(".0", "") + "K";
    }

    return num;
  };
  return (
    <>
      <Header />
      <div className="property-page">
        {/* ================= TOP SECTION ================= */}
        <div className="top-section">

          {/* LEFT : IMAGE GALLERY */}
          <div className="gallery">
            <div className="main-image">
              <img src={activeImage} alt="Property" />
            </div>

            <div className="thumbnail-row">
              {imageList.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt="thumbnail"
                  className={activeImage === img ? "active" : ""}
                  onClick={() => setActiveImage(img)}
                />
              ))}
            </div>
          </div>

          {/* RIGHT : CONTENT */}
          <div className="content-card">
            {/* <h1>Modern Office Complex 1</h1> */}
            <h1>{property?.title}</h1>

            {/* <p className="location">📍 Hitech City, Hyderabad, Telangana</p> */}

            <p className="location">📍 {property?.location}</p>


            {/* OWNER */}
            <div className="owner-card">
              <div className="owner-info">
                <img
                  src={residential}
                  alt="Owner"
                  className="owner-avatar"
                  style={{objectFit:'contain'}}
                />
                <div>

                  <h4>Propert Listed By</h4>
                  <span>Verified Seller</span>
                  {/* <p className="phone">+91 98765 43210</p> */}
                </div>
              </div>
              <div className="badges">

                <span>✔ Verified</span>
              </div>
            </div>

            {/* VERIFIED TAGS */}
            <div className="badges">
              <span>✔ GST Verified</span>
              <span>✔ Aadhaar Verified</span>
            </div>
            <div className="badges">
              <span>
                Category :  {property?.category}
              </span>
              </div>
               <div className="badges">
              <span>
                Price :  ₹ {formatPrice(property?.price)}
              </span>
              <span>
                Area :  {property?.area}
              </span>
            </div>

            {/* ACTION BUTTONS */}
            <div className="action-buttons">
              {/* <button className="primary">📅 Book Site Visit</button> */}
              <button
                className="primary"
                onClick={() => setVisitModalOpen(true)}
              >
                📅 Book Site Visit
              </button>

              {/* <button className="outline">Contact Owner</button> */}
            </div>

            {/* DESCRIPTION */}
            <h3>Description</h3>
            {/* <p>
            Experience luxury living in this architectural masterpiece.
            Featuring floor-to-ceiling windows, smart home automation,
            and premium amenities.
          </p> */}

            <p>{property?.description}</p>

          </div>
        </div>

        {/* ================= DOCUMENTS ================= */}
        <div className="documents">
          <h3>Documents</h3>

          <div className="doc-card">
            <div>
              <strong>No document available</strong>
              {/* <p>2.4 MB</p> */}
            </div>
            {/* <button>⬇</button> */}
          </div>
          {/*
          <div className="doc-card">
            <div>
              <strong>📄 Land Survey</strong>
              <p>1.8 MB</p>
            </div>
            <button>⬇</button>
          </div>

          <div className="doc-card">
            <div>
              <strong>📄 NOC Certificate</strong>
              <p>850 KB</p>
            </div>
            <button>⬇</button>
          </div>*/}
        </div>
      </div>


      <Modal
        isOpen={isVisitModalOpen}
        onRequestClose={() => setVisitModalOpen(false)}
        className="visit-modal"
        overlayClassName="visit-overlay"
      >
        <h2>Book Site Visit</h2>

        <div className="picker-group">
          <label>Select Date</label>
          <input
            type="date"
            value={visitDate}
            min={todayDate}
            onChange={(e) => setVisitDate(e.target.value)}
          />
        </div>

        <div className="picker-group">
          <label>Select Time</label>
          <input
            type="time"
            value={visitTime}
            onChange={(e) => setVisitTime(e.target.value)}
          />
        </div>

        <div className="modal-actions">
          <button onClick={() => setVisitModalOpen(false)}>
            Cancel
          </button>

          <button onClick={handleBookVisit}>
            Confirm Booking
          </button>
        </div>
      </Modal>

      <Footer />
    </>
  );
};

export default PropertyDetails;
